import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getActivationList = async (offset, itemsPerPage, activePage, params) => {
  const response = await agent.get(
    `${API_URL}game-activations/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}

const markPaid = async (data) => {
  const response = await agent.post(API_URL + 'game-activations/mark-paid', data)
  return response.data
}

const GameActivationService = {
  getActivationList,
  markPaid,
}

export default GameActivationService
